import * as DashboardConstants from '.././DashboardConstants';

export const queueTransactionTableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.BOTID
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'processName',
        header: DashboardConstants.ProcessName
    },
    {
        key: 'geography',
        header: DashboardConstants.Geo
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'supportStatus',
        header: DashboardConstants.SupportStatus
    },
    {
        key: 'businessMetric',
        header: DashboardConstants.BusinessMetric
    },
    {
        key: 'completed',
        header: DashboardConstants.Completed
    },
    {
        key: 'running',
        header: DashboardConstants.Running
    },
    {
        key: 'systemException',
        header: DashboardConstants.SystemException
    },
    {
        key: 'pending',
        header: DashboardConstants.Pending
    },
    {
        key: 'deferred',
        header: DashboardConstants.Deferred
    }
];

export const nonQueueTransactionTableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.BotID
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'processName',
        header: DashboardConstants.ProcessName
    },
    {
        key: 'geography',
        header: DashboardConstants.Geo
    },
    {
        key: 'processCriticality',
        header: DashboardConstants.ProcessCriticality
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'businessMetric',
        header: DashboardConstants.BusinessMetric
    },
    {
        key: 'successful',
        header: DashboardConstants.Successful
    },
    {
        key: 'failed',
        header: DashboardConstants.Failed
    }
];

export const QueueData = [
    {
        id: '1',
        botId: 1776,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    },
    {
        id: '2',
        botId: 1777,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    },
    {
        id: '3',
        botId: 1778,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    },
    {
        id: '4',
        botId: 1779,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    },
    {
        id: '5',
        botId: 1780,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    },
    {
        id: '6',
        botId: 1781,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU',
        businessMetric: 'Email_Arc_Default_Queue',
        completed: '49,423',
        systemException: '2',
        pending: '0',
        running: '5',
        deferred: '4'
    }

];

export const NonQueueData = [
    {
        id: '1',
        botId: 1776,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'
    },
    {
        id: '2',
        botId: 1777,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'
    },
    {
        id: '3',
        botId: 1778,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'
    },
    {
        id: '4',
        botId: 1779,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'

    },
    {
        id: '5',
        botId: 1780,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'

    },
    {
        id: '6',
        botId: 1781,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        businessMetric: 'Email_Arc_Default_Queue',
        successful: '5',
        failed: '4'
    }

];
export const TrendgroupedBarData = [
        {
            "group": "Succesful",
            "key": "Process1",
            "value": 65000
        },
        {
            "group": "Succesful",
            "key": "Process2",
            "value": 29123
        },
        {
            "group": "Succesful",
            "key": "Process3",
            "value": 35213
        },
        {
            "group": "Succesful",
            "key": "Process4",
            "value": 51213
        },
        {
            "group": "Failed",
            "key": "Process1",
            "value": 21312
        },
        {
            "group": "Failed",
            "key": "Process2",
            "value": 56456
        },
        {
            "group": "Failed",
            "key": "Process3",
            "value": 21312
        },
        {
            "group": "Failed",
            "key": "Process4",
            "value": 34234
        }
 ];